<template>
  <div class="main-content" style="min-height: 766px">
    <section class="section">
      <div class="section-header">
        <h1>Manage Suppression Accounts</h1>
      </div>

      <!-- Modal -->
      <b-modal id="modal-1" title="New Suppression Account" @ok="handleOk">
        <div class="form-group">
          <label class="control-label">Account Number</label>
          <input
            type="text"
            class="form-control"
            v-model.lazy="account"
            placeholder="eg. 18200"
          />
        </div>
      </b-modal>

      <div class="section-body">
        <div class="card">
          <div class="card-header">
            <h4>Suppression Account Table</h4>
            <div class="card-header-action">
              <button class="btn btn-warning mx-1" @click="exportExcel">
                Export
              </button>
              <button
                class="btn btn-sm btn-info mx-1"
                @click="chooseFileImport"
              >
                Import
              </button>
              <input ref="file" type="file" accept=".csv" hidden />
              <button class="btn btn-sm btn-primary" v-b-modal.modal-1>
                New Record
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4 mb-2">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                </b-input-group>
              </div>
            </div>
            <p class="small">There are {{ items.length }} Suppression Logins</p>
            <b-table
              class="tb-exposure"
              :sticky-header="true"
              :no-border-collapse="true"
              :filter="filter"
              striped
              hover
              bordered
              responsive
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
            >
              <template v-slot:cell(action)="data">
                <b-button
                  variant="danger"
                  @click="deleteSuppression(data.item.login)"
                >
                  <font-awesome-icon icon="trash" color="white" />
                </b-button>
              </template>
            </b-table>
          </div>
          <div class="card-footer bg-whitesmoke"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getAccounts, createAccount, deleteAccount, downloadAccount, uploadAccount } from "@/api/rule";
export default {
  data() {
    return {
      fields: [
        { key: "login", sortable: true, label: 'Login' },
        { key: "action", sortable: false, label: 'Action' },
      ],
      isBusy: false,
      items: [],
      filter: null,
      account: ""
    };
  },
  computed: {
    rows() {
      return this.items.length;
    }
  },
  mounted() {
    this.fetchData();

    // Watch file upload
    let fileInputElement = this.$refs.file;
    fileInputElement.onchange = () => {

      let formData = new FormData();
      formData.append('file', fileInputElement.files[0]);
      uploadAccount(formData).then(response => {
        this.$bvToast.toast(response.data.message, {
          title: `Success`,
          variant: 'success',
          solid: true
        })

      })
    };
  },
  beforeDestroy() {

  },
  destroyed() { },
  methods: {
    handleOk() {
      createAccount({ login: this.account }).then(() => {
        this.fetchData()
        this.$bvToast.toast(`Success adding record`, {
          title: 'Success',
          variant: 'primary',
          autoHideDelay: 5000
        })

        this.account = ''
      }).catch(() => {
        this.$bvToast.toast(`Failed while inserting record`, {
          title: 'Failed',
          variant: 'danger',
          autoHideDelay: 5000
        })
        this.account = ''
      })
    },
    fetchData() {
      getAccounts()
        .then(data => {
          this.items = data.data;
        })
        .catch(() => []);
    },
    deleteSuppression(login) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this record.', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          // Delete action
          if (value) {
            deleteAccount(login).then(() => {
              this.fetchData()
              this.$bvToast.toast(`Success delete record`, {
                title: 'Success',
                variant: 'primary',
                autoHideDelay: 5000
              })
            }).catch(() => {
              this.$bvToast.toast(`Failed while deleting record`, {
                title: 'Failed',
                variant: 'danger',
                autoHideDelay: 5000
              })
            })
          }
        })
        .catch(err => {
          // An error occurred

        })
    },
    exportExcel() {
      downloadAccount().then(response => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'text/csv'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', "supression_list.csv")
        document.body.appendChild(link)
        link.click()
      })
    },
    chooseFileImport() {
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    }

  }
};
</script>

<style scoped>
.tb-exposure {
  max-height: 500px;
}
</style>
